import {
    Component,
    Input,
    OnInit,
    OnDestroy,
    ChangeDetectionStrategy,
    inject,
    input,
    output,
} from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SubSink } from 'subsink';

@Component({
    selector: 'app-filter-form',
    templateUrl: './filter-form.component.html',
    styleUrls: ['./filter-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule],
})
export class FilterFormComponent implements OnInit, OnDestroy {
    private formBuilder = inject(FormBuilder);

    @Input() formGroup!: FormGroup<any>;

    readonly formSubmit = output<any>();

    readonly autoSubmitOnChange = input<boolean>(true);
    readonly showButtons = input<boolean>(false);

    private _sub = new SubSink();

    constructor() {
        this.formGroup = this.formBuilder.group({});
    }

    ngOnInit(): void {
        if (this.autoSubmitOnChange()) {
            this._sub.sink = this.formGroup.valueChanges.subscribe(() => {
                if (this.formGroup.valid) {
                    this.onSubmit();
                }
            });
        }
    }

    ngOnDestroy(): void {
        this._sub.unsubscribe();
    }

    onSubmit(): void {
        if (this.formGroup.valid) {
            this.formSubmit.emit(this.formGroup.value);
        } else {
            this.formGroup.markAllAsTouched();
        }
    }

    resetForm(): void {
        this.formGroup.reset();
    }
}
